import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import GridTable from "../../../Components/CommonTable/GridTable/GridTable";
import styles from "./store.module.css";
import { useFetchAll } from "../../../custom/FetchApiHook.jsx";
import { UsersApi } from "../../../App/api/users.api.js";
import filters from "./Filters.js";

const Store = ({ meta }) => {
  const [toggleUsers, SetToggleUser] = useState("STORE");
  const [gridToggle, SetGridToggle] = useState(false);

  const debounceTimeout = useRef();
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    sortOrder: "desc",
    filter: "",
  });

  const { value, fetchAllData } = useFetchAll(() =>
    UsersApi.getAllVendor(pagination)
  );

  const handlePagination = (data) => {
    // console.log(data);

    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }

    setPagination((prev) => {
      let copyfilter = { ...prev.filter };

      if (data.filter) {

        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(
            data.filter
          )[0];
        } else {
          copyfilter = { ...data?.filter, ...copyfilter };
        }
      }

      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };

  const handleSearch = useCallback((s) => {
    // console.log('Search at OrderCom', s);
    setSearch(s);
  }, []);

  filters.handleSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  filters.handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    handlePagination && handlePagination({ clearPagination });
  };
  filters.handleFilter = (name, value) => {
    console.table("name,value", name, value);
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    fetchAllData();
  }, [pagination, search]);
  return (
    <>
      <CommonLayout />
      <div style={{ paddingBottom: "4rem" }}>
        <div className={styles.users_toggle_container}>
          <span
            style={{
              color: toggleUsers === "STORE" ? "#e34e4e" : "var(--text-color3)",
            }}
            onClick={() => SetToggleUser("STORE")}
          >
            STORE
          </span>
        </div>

        <div style={{ padding: "2rem" }}>
          <GridTable
            FilterData={filters}
            handlePagination={handlePagination}
            isGrid={gridToggle}
            SetGridToggle={SetGridToggle}
            type={"store"}
            value={value}
            fetchAllData={fetchAllData}
          />
        </div>
      </div>
    </>
  );
};

export default Store;
